import type { MutableRefObject } from 'react';

import type { Assets } from '@/types';
import selectors from '@/ui/flux/selectors';
import useSelectorRef from './use-selector-ref.js';

function useAssetsRef(ref: MutableRefObject<Assets>) {
  useSelectorRef(selectors.assets.all, ref);
}

export default useAssetsRef;
